module.exports = __webpack_public_path__ + "5c20d26c.svg";